<section class="title-bar content-padding first-item content-padding">
    <div class="wrapper">
        <h2 class="left">{{ expertDeliveryRule?.id ? "Modifica" : "Nuovo"}} regola del valet</h2>
        <br class="clear">
    </div>
</section>

<section id="modificaConsegna" class="content-padding">
    <div class="narrow-wrapper">
        <form class="has-cols" [formGroup]="expertDeliveryRulesForm" (ngSubmit)="onSubmit()" *ngIf="expertDeliveryRulesForm">
            <div class="delivery-colle-data-box">
                <fieldset>
                    <legend>REGOLE:</legend>
                    <div class="col-48 grid-element" formGroupName="expert">
                        <label>Valet{{ expertDeliveryRulesForm.get('expert').get('id') | required }}</label>
                        <select id="selezionePartner" type="text" formControlName="id">
                          <option disabled></option>
                          <option *ngFor="let expert of experts" [value]="expert.id">{{expert.user.surname}} {{expert.user.name}}</option>
                        </select>
                        <app-error-html-handler [ctrl]="expertDeliveryRulesForm.get('expert').get('id')" [messages]="formValidationMsgs.expert.id"></app-error-html-handler>
                    </div> 
                    <div class="grid-element-full">
                        <div formArrayName="rules">
                            <div class="offer-products" *ngFor="let rule of expertDeliveryRulesForm.get('rules').controls; let i = index">
                                <div [formGroupName]="i" class="" style="display: table; width: 100%;">
                                    <i class="far fa-times-circle hvr-grow remove-product remove-rule"  (click)="removeRule(i)"></i>
                                    <fieldset class="rules-fieldset">
                                        <legend>REGOLE</legend>
                                        <div class="col-48 grid-element">
                                            <label>OPERATOR{{ rule.get('operator') | required }}</label>
                                            <select formControlName="operator">
                                                <option value="equal">=</option>
                                                <option value="lessThan"><</option>
                                                <option value="moreThan">></option>
                                            </select>
                                            <app-error-html-handler [ctrl]="rule.get('operator')" [messages]="formValidationMsgs.rules.operator"></app-error-html-handler>
                                        </div>
                                        <div class="col-48 grid-element">
                                            <label>NUMERO RITIRI{{ rule.get('pickUps') | required }}</label>
                                            <input type="text" formControlName="pickUps">
                                            <app-error-html-handler [ctrl]="rule.get('pickUps')" [messages]="formValidationMsgs.rules.pickUps"></app-error-html-handler>
                                        </div>
                                        <div class="col-48 grid-element">
                                            <label>Plus Salary{{ rule.get('plusSalary') | required }}</label>
                                            <input type="text" formControlName="plusSalary" placeholder="">
                                            <app-error-html-handler [ctrl]="rule.get('plusSalary')" [messages]="formValidationMsgs.rules.plusSalary"></app-error-html-handler>
                                        </div> 
                                    </fieldset>
                                </div>
                            </div>
                        </div>
                        <div style="margin-top: 15px;" class="grid-element-full center" *ngIf="expertDeliveryRulesForm.get('rules').hasError('duplicateOperator')">
                            <span class="error-message" style="color: red;">{{ formValidationMsgs.rules.duplicateOperator }}</span>
                        </div>
                        <div class="center" style="width: 100%;">
                          <button class="btn mt-5" (click)="$event.preventDefault(); addRule()">
                            Aggiungi Regole<i class="ml-10 fas fa-plus"></i>
                          </button>
                        </div>
                    </div>
                    <div class="delivery-colle-data-box" style="margin-top: 15px;">
                        <fieldset class="rules-fieldset">
                            <legend>ASSOCIATE VALETS:</legend>
                            <div class="grid-element-full">
                                <div formArrayName="associateExpertWithRule" class="mb-5">
                                    <div class="offer-products" *ngFor="let expertForm of expertDeliveryRulesForm.get('associateExpertWithRule').controls; let i = index">
                                        <div [formGroupName]="i" class="" style="display: table; width: 100%;">
                                            <label for=""></label>
                                            <div style="display: table-cell; width: 19px;">
                                                <i class="far fa-times-circle hvr-grow remove-expert"  (click)="removeAssociateExpert(i)"></i>
                                            </div>
                                            <div class="product-q" formGroupName="expert">
                                                <div class="porduct-qty">
                                                    <div class="province-input">
                                                        <label for=""></label>
                                                        <ng-select 
                                                            formControlName="id"
                                                            class="product-category"
                                                            [multiple]="false" 
                                                            [hideSelected]="true"
                                                            [closeOnSelect]="true"
                                                            [searchable]="true" 
                                                            [clearable]="true"
                                                            [virtualScroll]="true"
                                                        >
                                                            <ng-option *ngFor="let expert of experts" [value]="expert.id" [disabled]="isAssociateExpertOptionDisabled(expert)">{{expert.user.surname}} {{expert.user.name}}</ng-option>
                                                        </ng-select>
                                                    </div>
                                                </div>
                                            </div>
                                            <app-error-html-handler [ctrl]="expertForm?.controls?.expert.controls?.id" [messages]="formValidationMsgs?.associateExpertWithRule?.expert.id"></app-error-html-handler>
                                        </div>
                                    </div>
                                </div>
                                <div class="center" style="width: 100%;">
                                    <button class="btn mt-0" (click)="$event.preventDefault(); addAssociateExpert()">
                                        Aggiungi Valet<i class="ml-10 fas fa-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </fieldset>
                <div class="center" style="margin-top: 15px;">
                    <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit()" [disabled]="!expertDeliveryRulesForm?.valid || tmpBtnDisabled">Salva<i class="ml-10 far fa-save"></i></button>
                </div>
            </div>
        </form>
    </div>
</section>